import { render } from "./ProductCreate.vue?vue&type=template&id=3954e8fc"
import script from "./ProductCreate.vue?vue&type=script&lang=js"
export * from "./ProductCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__